// dd-variant-matrix — single delegated handler, initialises once
(function(){
  if(window.__ddVmInit) return;
  window.__ddVmInit = true;

  var activePanel = null;

  function getVm(el){ return el && el.closest ? el.closest('.dd-vm') : null; }

  function positionPanel(vm){
    var trigger = vm.querySelector('.dd-vm__trigger');
    var panel   = vm.querySelector('.dd-vm__panel');
    if(!trigger||!panel) return;
    var rect = trigger.getBoundingClientRect();
    panel.style.top   = rect.bottom + 'px';
    panel.style.left  = rect.left   + 'px';
    panel.style.width = rect.width  + 'px';
  }

  function openVm(vm){
    if(activePanel && activePanel !== vm) closeVm(activePanel);
    activePanel = vm;
    positionPanel(vm);
    vm.setAttribute('open','');
    vm.querySelector('.dd-vm__trigger').setAttribute('aria-expanded','true');
    vm.querySelector('.dd-vm__panel').setAttribute('aria-hidden','false');
  }

  function closeVm(vm){
    if(!vm) return;
    vm.removeAttribute('open');
    vm.querySelector('.dd-vm__trigger').setAttribute('aria-expanded','false');
    vm.querySelector('.dd-vm__panel').setAttribute('aria-hidden','true');
    if(activePanel === vm) activePanel = null;
  }

  // Single delegated click handler
  document.addEventListener('click', function(e){
    var vm = getVm(e.target);

    // Outside click — close active
    if(!vm){
      if(activePanel) closeVm(activePanel);
      return;
    }

    // Trigger click
    if(e.target.closest('.dd-vm__trigger')){
      e.stopPropagation();
      vm.hasAttribute('open') ? closeVm(vm) : openVm(vm);
      return;
    }

    // Row click — add to cart
    var row = e.target.closest('.dd-vm__row--available');
    if(!row || row.classList.contains('dd-vm__row--adding')) return;
    e.stopPropagation();

    var variantId = row.dataset.variantId;
    var stockEl   = row.querySelector('.dd-vm__row-stock');
    var origStock = stockEl ? stockEl.textContent : '';

    row.classList.add('dd-vm__row--adding');

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{
      bubbles:true, detail:{ sections: sectionsToBundle }
    }));

    var config = theme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      id: parseInt(variantId), quantity: 1,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    });

    fetch(theme.routes.cart_add_url, config)
      .then(function(r){ return r.json(); })
      .then(function(state){
        if(state.status){
          row.classList.remove('dd-vm__row--adding');
          if(stockEl) stockEl.textContent = state.description || 'Error';
          setTimeout(function(){ if(stockEl) stockEl.textContent = origStock; }, 2000);
          return;
        }
        row.classList.remove('dd-vm__row--adding');
        row.classList.add('dd-vm__row--added');
        if(stockEl) stockEl.textContent = 'Added!';

        fetch(theme.routes.cart_url, theme.utils.fetchConfig('json','GET'))
          .then(function(r){ return r.json(); })
          .then(function(cartJson){
            cartJson['sections'] = state['sections'];
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{
              source:'product-form', productVariantId: variantId, cart: cartJson
            });
          });

        document.dispatchEvent(new CustomEvent('ajaxProduct:added',{
          bubbles:true, detail:{ product: state }
        }));

        var cartDrawer = document.querySelector('cart-drawer');
        if(cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();

        setTimeout(function(){
          row.classList.remove('dd-vm__row--added');
          if(stockEl) stockEl.textContent = origStock;
          closeVm(vm);
        }, 1500);
      })
      .catch(function(){ row.classList.remove('dd-vm__row--adding'); });
  });

  // Single scroll/resize handler — only repositions if a panel is open
  function reposition(){
    if(activePanel) positionPanel(activePanel);
  }
  window.addEventListener('scroll', reposition, {passive:true});
  window.addEventListener('resize', reposition, {passive:true});

})();
